import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface BloodTypeState {
  bloodTypeByPatient: Record<string, string | null>; // patientId -> bloodType display string
}

const initialState: BloodTypeState = {
  bloodTypeByPatient: {},
};

const bloodTypeSlice = createSlice({
  name: "bloodType",
  initialState,
  reducers: {
    setBloodType: (
      state,
      action: PayloadAction<{ patientId: string; bloodType: string | null }>,
    ) => {
      state.bloodTypeByPatient[action.payload.patientId] = action.payload.bloodType;
    },
    clearBloodType: (state, action: PayloadAction<string>) => {
      delete state.bloodTypeByPatient[action.payload];
    },
  },
});

export const { setBloodType, clearBloodType } = bloodTypeSlice.actions;

export const selectBloodType = (patientId: string | undefined) => (state: RootState) =>
  patientId ? (state.bloodType.bloodTypeByPatient[patientId] ?? null) : null;

export const selectHasBloodTypeData = (patientId: string | undefined) => (state: RootState) =>
  patientId ? patientId in state.bloodType.bloodTypeByPatient : false;

export default bloodTypeSlice.reducer;
